import { PartnershipsProvider } from '@skyslope/partnerships-sdk/react';
import { useSelector } from 'react-redux';
import { IRootState } from '../store';
import React, { useMemo } from 'react';
import {LoadAdsParams, PartnerAdAudience, PartnerAdPlacement} from '@skyslope/partnerships-sdk';
import { DATADOG_ENV } from '../common/constants';

export enum AdPlacementIds {
  SIGNING = 'ds-signing',
  SIGNED = 'ds-signed',
}

const audienceTypeMap: Record<string, PartnerAdAudience> = {
  seller: PartnerAdAudience.Seller,
  buyer: PartnerAdAudience.Buyer,
};

const useEnvelopeData = () => {
  return useSelector((state: IRootState) => state.envelope.envelope);
};

const DigiSignAdsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const envelope = useEnvelopeData();

  const loadAdParams = useMemo((): LoadAdsParams => {
    const audience = envelope?.signer?.metadata?.['audienceContactType']?.toLowerCase();
    const audienceType = audience && audienceTypeMap[audience] ? audienceTypeMap[audience] : PartnerAdAudience.Agent;
    return {
      regions: envelope?.metadata?.ownerRegionCountries?.split(',').map(region => region?.trim()),
      subscriberId: envelope?.metadata?.ownerSubscriberId,
      audience: audienceType,
    }
  }, [envelope]);

  const environment = DATADOG_ENV ?? 'prod'; // todo - migrate to use env
  const loaded =
    loadAdParams.audience != null &&
    loadAdParams.regions != null &&
    loadAdParams.subscriberId != null &&
    environment != null;

  return (
    <PartnershipsProvider environment={environment} loadAdsParams={loadAdParams} ready={loaded} defaultPlacement={PartnerAdPlacement.DS3SignerGeneral}>
      {children}
    </PartnershipsProvider>
  );
};

export default DigiSignAdsProvider;
